import React from 'react';
import { SaveSection } from '../../SaveSection';
import { Button } from '../../ui';

interface SidebarProps {
  totalProgress: number;
  isAllChecked: boolean;
  onReset: () => void;
  onSave: () => void;
  preparationReady: boolean;
}

export function Sidebar({ totalProgress, isAllChecked, onReset, onSave, preparationReady }: SidebarProps) {
  return (
    <div className="w-full lg:w-80 border-t lg:border-t-0 lg:border-l border-navy-700 p-2 sm:p-3 bg-navy-800 overflow-auto">
      {/* Ações (sempre visível) */}
      <div className="bg-navy-700 rounded-lg p-2 sm:p-3 sticky bottom-0 z-10 border-t border-navy-600 shadow-[0_-6px_12px_-8px_rgba(0,0,0,0.5)]">
        <h3 className="text-xs sm:text-sm font-medium text-white mb-2">Ações</h3>
        <SaveSection onSave={onSave} disabled={!isAllChecked || !preparationReady}>
          {/* Mantém o botão Reset e a dica como filhos, sem alterar handlers */}
          <div className="flex flex-col gap-2 mb-2">
            <Button
              variant="secondary"
              size="xs"
              onClick={onReset}
              className="w-full"
              type="button"
            >
              Resetar
            </Button>
          </div>
          {!isAllChecked && (
            <p className="text-xs text-gray-400 mb-2">
              Marque todos os itens para habilitar o salvamento.
            </p>
          )}
          {isAllChecked && !preparationReady && (
            <p className="text-xs text-yellow-300 mb-2">
              Preparando documento… aguarde a coleta inicial antes de salvar.
            </p>
          )}
        </SaveSection>
      </div>
    </div>
  );
}